import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import {
    ItemSectionDiv,
    AppListItemDiv,
    AppNameDiv,
    TagsDiv
} from  '../../Styles/Components/AppListItemStyles'

import { useSelector, useDispatch } from "react-redux"
import { setLock, setMode, setCurrentApplicationID } from '../../Redux/Slices/AppViewerSlice'

function AppListItem(props){
    let history = useHistory()

    const dispatch = useDispatch()
    const hubPage = useSelector(state => state.hub.hubPage)

    var item = props.item

    function viewApplication(e){
        dispatch(setLock({locked: true}))
        dispatch(setMode({mode: 'update'}))
        dispatch(setCurrentApplicationID({currentApplicationID: item.id}))
        history.push({
            pathname: '/appviewer/'+hubPage,
            state: {
                data: item,
            },
        })
    }

    return (
        <AppListItemDiv onClick={viewApplication}>
            <ItemSectionDiv>
                <AppNameDiv>
                    {item.application_details.name}
                </AppNameDiv>
            </ItemSectionDiv>
            <ItemSectionDiv>
                <TagsDiv>
                    {item.application_details.tags}
                </TagsDiv>
            </ItemSectionDiv>
        </AppListItemDiv>
    )
}

export default AppListItem